import { CircularProgress, CssBaseline, ThemeProvider } from '@mui/material';
import theme from '../theme';

const LoadingContainer = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div style={styles.loadingContainer}>
                <CircularProgress size={48} />
            </div>
        </ThemeProvider>
    )
}

const styles = {
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
    }
}

export default LoadingContainer